import { useState, useContext } from "react";
import AdminLeloContext from "../../context/adminLelo/adminLeloContext";
import * as FaIcons from "react-icons/fa";

const LeloColumnManager = ({ isOpen, onClose }) => {
  const adminLeloContext = useContext(AdminLeloContext);
  const { visibleColumns, toggleColumn } = adminLeloContext;

  const allColumns = [
    { name: "createdAt", display: "Submit Date", required: true },
    { name: "status", display: "Status", required: false },
    { name: "firstName", display: "Student Name", required: true },
    { name: "learningCenters", display: "Learning Center", required: false },
    { name: "studentPrimaryPhone", display: "Phone Number", required: false },
    { name: "studentEmail", display: "Email", required: false },
    { name: "uploadedUrl", display: "Signed Agreement", required: false },
    { name: "permaLink", display: "Permalink", required: false },
  ];

  const [draggedItem, setDraggedItem] = useState(null);

  const handleDragStart = (e, index) => {
    setDraggedItem(index);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedItem === null || draggedItem === index) return;
    setDraggedItem(index);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  const handleToggleColumn = (columnName) => {
    const column = allColumns.find((col) => col.name === columnName);
    if (column && column.required) return; // Don't toggle required columns

    // Toggle immediately in context
    toggleColumn(columnName);
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="column-manager-overlay" onClick={onClose}></div>

      {/* Sidebar */}
      <div className={`column-manager ${isOpen ? "open" : ""}`}>
        <div className="column-manager-header">
          <div>
            <h3>Organize Columns</h3>
            <p className="column-manager-subtitle">
              Drag to reorder • Show/hide columns
            </p>
          </div>
          <button className="close-btn" onClick={onClose}>
            <FaIcons.FaTimes />
          </button>
        </div>

        <div className="column-manager-content">
          {allColumns.map((column, index) => {
            const isColumnVisible = visibleColumns[column.name] !== false;
            const isDisabled = column.required; // Only disable required columns

            return (
              <div
                key={column.name}
                className={`column-item ${draggedItem === index ? "dragging" : ""} ${
                  isColumnVisible ? "visible" : ""
                }`}
                draggable={!column.required}
                onDragStart={(e) => handleDragStart(e, index)}
                onDragOver={(e) => handleDragOver(e, index)}
                onDragEnd={handleDragEnd}
              >
                <div className="column-item-left">
                  <FaIcons.FaGripVertical className="drag-handle" />
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      checked={isColumnVisible}
                      onChange={() => handleToggleColumn(column.name)}
                      disabled={isDisabled}
                    />
                    <span className="column-name">
                      {column.display}
                      {column.required && " (Required)"}
                    </span>
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default LeloColumnManager;
